export default __webpack_public_path__ + "static/media/pagination-label-next.8ff0228a.svg";